<template>
    <div>
        <el-dialog class="payment-dialog" title="支付申请" :visible.sync="paymentShow" :before-close="paymentShowClose" :close-on-click-modal="false" width="50%" v-loading="paymentLoading">
            <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" class="row-box">
                <template v-if="checkIsCashPay">
                    <div class="deposit">现汇付款</div>
                    <el-table border :data="ruleForm.applicationForPaymentModel" max-height="150">
                        <el-table-column prop="payType" label="缴纳方式" >
                            <template slot-scope="scope">
                                <el-form-item prop="payType" v-model="ruleForm.applicationForPaymentModel[scope.$index].payType" :rules="rules.payType">
                                    <selects
                                        :filterable="true"
                                        :optionNum="'SYS_BMS_DEPOSIT_CASH_TYPE'"
                                        :prop="'payType'"
                                        @getSelectValue="getSelectValue"
                                    ></selects>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="applyAmt" label="缴纳金额" >
                            <template slot-scope="scope">
                                <el-form-item
                                    :prop="'applicationForPaymentModel.' + scope.$index + '.applyAmt'"
                                    :rules="rules.applyAmt"
                                    class="label-form">
                                    <el-input
                                        @keyup.native="inputpayMoney(ruleForm.applicationForPaymentModel[scope.$index].applyAmt, scope)"
                                        v-model.trim="ruleForm.applicationForPaymentModel[scope.$index].applyAmt"
                                        placeholder="请输入缴纳金额" clearable>
                                    </el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <upload :dataUpload="dataUpload" type="1" v-if="scope.row.editing === 'arrive'" :accept="'image/*'" :text="'附件上传'"
                                :flag="String(scope.$index)" :uploadDisplayType="'text'" @uploadSuccess="uploadSuccess"></upload>
                                <span :title="ruleForm.applicationForPaymentModel[scope.$index].imgName" class="image-dialog" v-else-if="scope.row.editing === 'arriveCell'"
                                @click="imgDialog(scope.row)">{{ruleForm.applicationForPaymentModel[scope.$index].imgName}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>

                <template v-if="isAdjustment">
                    <div class="deposit">押金调账</div>
                    <el-table border :data="ruleForm.depositTransfer" style="width: 100%" max-height="150">
                        <el-table-column prop="fromSupCashNo" label="押金单号" >
                            <template slot-scope="scope">
                                <el-form-item :prop="'depositTransfer.' + scope.$index + '.fromSupCashNo'" :rules="rules.fromSupCashNo">
                                    <el-select clearable
                                    @clear="clearClick(scope.$index,scope.row)"
                                    v-model="ruleForm.depositTransfer[scope.$index].fromSupCashNo" placeholder="请选择"
                                    @change="(val) => {changeHandler(val,scope.$index,scope.row)}" value-key="jobId">
                                        <el-option v-for="item in ruleForm.depositOptions" :key="item.jobId" :label="item.montage"
                                            :value="item" :disabled="item.disabled"></el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="budgetAmt" label="已缴金额" width="130"></el-table-column>
                        <el-table-column prop="balanceAmt" label="余额" width="130"></el-table-column>
                        <el-table-column prop="applyAmt" label="调账金额">
                            <template slot-scope="scope">
                                <el-form-item
                                    :prop="'depositTransfer.' + scope.$index + '.applyAmt'"
                                    :rules="rules.applyAmt"
                                    class="label-form">
                                    <el-input
                                        @focus="accountFocus(ruleForm.depositTransfer[scope.$index].applyAmt, scope)"
                                        @keyup.native="accountAdjustment(ruleForm.depositTransfer[scope.$index].applyAmt,
                                        scope)" v-model.trim="ruleForm.depositTransfer[scope.$index].applyAmt" placeholder="请输入调账金额" clearable>
                                        </el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button @click="handleDepositClick(scope.row)" type="text" size="small">
                                    <i class="el-icon-circle-plus-outline add-icon"></i>
                                </el-button>
                                <el-button @click="cellDepositClick(scope.$index, ruleForm.depositTransfer)" type="text" size="small">
                                    <i class="el-icon-circle-close delete-icon"></i>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>

                <template v-if="isReceivable">
                    <div class="deposit">应收转押金</div>
                    <el-table border :data="ruleForm.receivableTransferDepositModel" style="width: 100%" max-height="150">
                        <el-table-column prop="apApplyNo" label="未结单号">
                            <template slot-scope="scope">
                                <el-form-item :prop="'receivableTransferDepositModel.' + scope.$index + '.apApplyNo'" :rules="rules.apApplyNo">
                                    <el-select clearable
                                    @clear="clearHandClick(scope.$index,scope.row)"
                                    v-model="ruleForm.receivableTransferDepositModel[scope.$index].apApplyNo"
                                    placeholder="请选择" @change="(val) => {changeHandlerList(val,scope.$index,scope.row)}" value-key="jobId">
                                        <el-option v-for="item in ruleForm.depositReceivableOptions" :key="item.jobId" :label="item.montage" :value="item" :disabled="item.disabled"></el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="apAmt" label="应收金额" width="130"></el-table-column>
                        <el-table-column prop="apRealAmt" label="未收金额" width="130"></el-table-column>
                        <el-table-column prop="applyAmt" label="转押金金额">
                            <template slot-scope="scope">
                                <el-form-item :prop="'receivableTransferDepositModel.' + scope.$index + '.applyAmt'" :rules="rules.applyAmt"
                                    class="label-form">
                                    <el-input
                                    @focus="depositChange(ruleForm.receivableTransferDepositModel[scope.$index].applyAmt, scope)"
                                    @keyup.native="depositReceivable(ruleForm.receivableTransferDepositModel[scope.$index].applyAmt,
                                    scope)" v-model.trim="ruleForm.receivableTransferDepositModel[scope.$index].applyAmt" placeholder="请输入转押金金额" clearable></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                         <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.row)" type="text" size="small">
                                    <i class="el-icon-circle-plus-outline add-icon"></i>
                                </el-button>
                                <el-button @click="cellClick(scope.$index, ruleForm.receivableTransferDepositModel)" type="text" size="small">
                                    <i class="el-icon-circle-close delete-icon"></i>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <div class="footer-top">
                    <div class="footer-left">
                        <div class="summation">申请合计: <span class="summation-money">{{total}}</span> 元</div>
                        <div class="esign-field" v-if="!checkIsCashPay">
                            <span class="esign-label">是否电子签章：</span>
                            <el-select class="esign-select" v-model="eSign" size="mini" style="width: 120px;" placeholder="请选择">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <form id="formCommit" class="footer-right" :action="config.mideaPay" method="post">
                        <input type="hidden" :name="key" :value="val" v-for="(val,key) of payResult" :key="key">
                        <input v-if="!checkIsCashPay && eSign==='1'" type="button" id="subText" class="submission" @click="electronicSign('ruleForm')" value="去签订">
                        <input v-else type="button" id="subText" class="submission" :disabled="isDisable" @click="paymentOk('ruleForm')" value="提 交">
                    </form>
                </div>
                <upload
                    v-if="!checkIsCashPay && eSign==='0'"
                    :dataUpload="dataUpload"
                    type="2"
                    :accept="'.doc,.docx,.pdf'"
                    :text="'上传附件'"
                    :flag="'footer'"
                    :uploadDisplayType="'button'"
                    :showFileList="true"
                    @uploadSuccess="uploadSuccessFooter"
                >
                </upload>
                <div v-if="!checkIsCashPay" class="esign-tips">
                    {{ eSign ==='1' ? '提示：走电子签章的押金调账/应收转押金请查阅' : '提示：不走电子签章的押金调账/应收转押金，请下载' }}
                    <span class="hyperlink" @click="downloadPDF">{{ eSign ==='1' ? '《押金调整函件》' : '《押金调整函模板》' }}</span>
                    {{ eSign ==='1' ? '查阅后点击去签订进行盖印再提交申请' : '，完成盖章后上传对应附件' }}
                </div>
            </div>
        </el-dialog>
        <Picture v-if="diaShaow" :data="rowData" :imgLookName="imgName" :uploadTime="uploadTime" :imgUrl="imgUrl" :updateUserName="updateUserName"
        :diaShaow="diaShaow" @handleStartClose="handleStartClose" @deleteBtn="deleteBtn" @uploadSuccess="uploadListSuccess"></Picture>
    </div>
</template>
<script>
import upload from '../components/Upload';
import Picture from './Picture';
import selects from '@/components/lots/otpSelect';
import { TIMER, CHECK } from '../../../../utils/configuration';
import { dateTime } from '../../../../components/time/dateTimes.js';
import { onlyInputnumber, messageBox } from '../../../../components/judge/bmsModular';
import { getAccountLists, getReceivableLists, getPictureDeletion } from '../../../../api/payment.js';
// eslint-disable-next-line no-irregular-whitespace
import config from '@/config/user.env.js';
export default {
    components: { upload, Picture, selects },
    props: {
        paymentShow: {
            type: Boolean,
            default: false
        },
        dataPayLists: {
            type: Object
        },
        paymentLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            config,
            disabled: false,
            isDisable: false,
            isPaymentDisabled: true,
            scope: {},
            eSign: '1',
            footerFileId: '',
            footerFileName: '',
            footerFileUrl: '',
            ruleForm: {
                applicationForPaymentModel: [
                    {
                        payType: '', // 缴纳方式
                        applyAmt: 0, // 申请金额
                        applyType: 1, // 申请类型
                        approveStatus: 20, // 审批状态
                        fromSupCashNo: '', // 调账押金单号
                        editing: 'arrive',
                        imgName: '',
                        updateUserName: '',
                        imgUrl: '',
                        uploadTime: ''
                    }
                ],
                depositTransfer: [
                    {
                        payType: 4, // 缴纳方式
                        applyAmt: 0, // 调账金额
                        applyType: 1, // 申请类型
                        approveStatus: 20, // 审批状态
                        fromSupCashNo: '' // 调账押金单号
                    }
                ],
                receivableTransferDepositModel: [
                    {
                        payType: 3, // 缴纳方式
                        applyAmt: 0, // 申请金额
                        applyType: 1, // 申请类型
                        approveStatus: 20, // 审批状态
                        fromSupCashNo: '', // 调账押金单号
                        apApplyNo: '' // 未结单号
                    }
                ],
                depositReceivableOptions: [],
                depositOptions: []
            },
            rules: {},
            value: '',
            imgUrl: '',
            updateUserName: '',
            imgName: '',
            uploadTime: '',
            rowData: {},
            payResult: {},
            diaShaow: false,
            isCashPay: true,
            isAdjustment: true,
            isReceivable: true,
            dataValue: '',
            depositObj: {},
            dataUpload: {
                jobId: '',
                ruleForm: {
                    applicationForPaymentModel: [
                        {
                            editing: 'arrive',
                            imgName: '',
                            updateUserName: '',
                            imgUrl: '',
                            uploadTime: ''
                        }
                    ]
                }
            },
            pictureId: '',
            deid: ''
        };
    },
    created() {
        this.depositbillNumber();
        this.accountLists();
        this.dataUpload.jobId = this.dataPayLists.jobId;
    },
    methods: {
        checkPayment() {
            const pattern = /[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\>|\/|\?]/g;
            const totals = this.total ? this.total : '';
            const formNameNum = Number(totals.replace(pattern, ''));
            if (formNameNum <= 0) {
                this.$message.warning('申请金额必须大于0');
                return false;
            }
            const receivableList = this.ruleForm.receivableTransferDepositModel;
            const depoLists = this.ruleForm.depositTransfer;
            if (depoLists.length > 1) {
                const dataLists = depoLists.filter(item => {
                    return item.fromSupCashNo === '' || item.applyAmt === '';
                });
                if (dataLists.length >= 1) {
                    this.$message.warning('押金单号或者调账金额不可漏填');
                    return false;
                }
            }
            depoLists.forEach(item => {
                if (item.balanceAmt !== '' && Number(item.applyAmt) > Number(item.balanceAmt)) {
                    this.$message.warning('调账金额必须小于等于当前单号对应的余额');
                    return false;
                }
            });
            if (receivableList.length > 1) {
                const dataDepostLists = receivableList.filter(item => {
                    return item.apApplyNo === '' || item.applyAmt === '';
                });
                if (dataDepostLists.length >= 1) {
                    this.$message.warning('未结单号或者转押金金额不可漏填');
                    return false;
                }
            }
            receivableList.forEach(item => {
                if (item.apAmt !== '' && Number(item.applyAmt) > Number(item.apAmt)) {
                    this.$message.warning('转押金金额必须小于等于未收金额');
                    return false;
                }
            });
            return true;
        },
        downloadPDF() {
            if (!this.checkPayment()) {
                return false;
            }
            this.$emit('downloadPDF', this.ruleForm);
        },
        getSelectValue(data) {
            this.ruleForm = { ...this.ruleForm, ...data };
            this.dataValue = data.payType;
            if (this.dataValue) {
                this.isAdjustment = false;
                this.isReceivable = false;
                this.ruleForm.applicationForPaymentModel[0].applyAmt = this.dataPayLists.budgetAmt;
            } else {
                this.isAdjustment = true;
                this.isReceivable = true;
                this.ruleForm.applicationForPaymentModel[0].applyAmt = 0;
                this.ruleForm.applicationForPaymentModel[0].imgName = '';
            }
        },
        uploadSuccess(data) {
            this.$nextTick(() => {
                this.dataUpload.ruleForm.applicationForPaymentModel[0].editing = 'arriveCell';
                this.dataUpload.ruleForm.applicationForPaymentModel[0].imgName = data.fileName;
            });
            this.pictureId = data.data.jobId;
            const upData = this.ruleForm.applicationForPaymentModel[data.flag];
            upData.editing = 'arriveCell';
            upData.imgName = data.data.fileName;
            this.imgName = upData.imgName;
            this.updateUserName = upData.updateUserName = data.data.userCode;
            upData.imgUrl = data.data.url;
            upData.uploadTime = dateTime();
        },
        // 页脚上传附件（非电子签章）
        uploadSuccessFooter(data) {
            this.footerFileId = data.data.jobId;
            this.footerFileName = data.data.fileName;
            this.footerFileUrl = data.data.url;
        },
        imgDialog(row) {
            this.rowData = row;
            this.imgUrl = row.imgUrl;
            this.updateUserName = row.updateUserName;
            this.uploadTime = row.uploadTime;
            this.diaShaow = true;
        },
        // 图片预览的上传
        uploadListSuccess(data) {
            this.imgName = data.data.fileName;
            this.updateUserName = data.data.userCode;
            this.imgUrl = data.data.url;
            this.uploadTime = dateTime();
        },
        deleteBtn() {
            getPictureDeletion([this.pictureId]).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('删除成功');
                    this.ruleForm.applicationForPaymentModel[0].imgName = '';
                    this.ruleForm.applicationForPaymentModel[0].imgUrl = '';
                    this.$nextTick(() => {
                        this.diaShaow = false;
                        this.ruleForm.applicationForPaymentModel[0].editing = 'arrive';
                    });
                }
            }).catch(() => {});
        },
        handleStartClose(data) {
            this.ruleForm.applicationForPaymentModel[0].imgName = data.imgLookName;
            this.ruleForm.applicationForPaymentModel[0].imgUrl = this.imgUrl;
            this.diaShaow = false;
        },
        handleClick(receivableTransferDepositModel, row) {
            this.ruleForm.receivableTransferDepositModel.push({
                payType: 3, // 缴纳方式
                applyAmt: 0, // 申请金额
                applyType: 1, // 申请类型
                approveStatus: 20, // 审批状态
                fromSupCashNo: '', // 调账押金单号
                apApplyNo: '' // 未结单号
            });
        },
        cellClick(index, rows) {
            if (rows[index].apApplyNo !== '') {
                this.ruleForm.depositReceivableOptions.find(item => item.montage === rows[index].apApplyNo.montage).disabled = false;
            }
            const receivableData = this.ruleForm.receivableTransferDepositModel;
            if (receivableData.length === 1) {
                Object.keys(receivableData[0]).forEach(item => {
                    receivableData[0][item] = '';
                });
            } else {
                rows.splice(index, 1);
            }
        },
        handleDepositClick() {
            this.ruleForm.depositTransfer.push(
                {
                    payType: 4, // 缴纳方式
                    applyAmt: 0, // 申请金额
                    applyType: 1, // 申请类型
                    approveStatus: 20, // 审批状态
                    fromSupCashNo: '', // 调账押金单号
                    apRealAmt: '', // 已缴金额
                    balanceAmt: '' // 余额
                }
            );
        },
        cellDepositClick(index, rows) {
            if (rows[index].fromSupCashNo !== '') {
                this.ruleForm.depositOptions.find(item => item.montage === rows[index].fromSupCashNo.montage).disabled = false;
            }
            const depositDatas = this.ruleForm.depositTransfer;
            if (depositDatas.length === 1) {
                Object.keys(depositDatas[0]).forEach(item => {
                    depositDatas[0][item] = '';
                });
            } else {
                rows.splice(index, 1);
            }
        },
        depositbillNumber() {
            const params = { companyCode: this.dataPayLists.companyCode, siteCode: this.dataPayLists.siteCode, supCode: this.dataPayLists.suppCode, supCashNo: this.$route.query.supCashNo };
            getAccountLists(params).then(res => {
                if (res && res.code === '0') {
                    this.ruleForm.depositOptions = res.data.list;
                }
            }).catch(() => {});
        },
        accountLists() {
            const params = { suppCode: this.dataPayLists.suppCode, companyCode: this.dataPayLists.companyCode, currencyCode: this.dataPayLists.currencyCode, ledgerId: this.dataPayLists.ledgerId };
            getReceivableLists(params).then(res => {
                if (res && res.code === '0') {
                    this.ruleForm.depositReceivableOptions = res.data;
                }
            }).catch(() => {});
        },
        changeHandler(val, index, rows) {
            // this.isCashPay = this.ruleForm.depositTransfer[index].fromSupCashNo ? false : true;
            // console.log('changeHandler',this.ruleForm.depositTransfer[index].fromSupCashNo);
            rows.budgetAmt = rows.fromSupCashNo.budgetAmt;
            rows.balanceAmt = rows.fromSupCashNo.balanceAmt;
            this.ruleForm.depositOptions.forEach(item => {
                item['disabled'] = false;
            });
            this.ruleForm.depositTransfer.forEach(item => {
                if (item.fromSupCashNo !== '') {
                    this.ruleForm.depositOptions.find(item2 => {
                        return item2.montage === item.fromSupCashNo.montage;
                    }).disabled = true;
                }
            });
        },
        clearClick(index, rows) {
            if (this.ruleForm.depositOptions[index] !== undefined) {
                this.ruleForm.depositOptions[index].disabled = false;
            } else {
                rows.splice(index, 1);
            }
        },
        changeHandlerList(val, index, rows) {
            // this.isCashPay = this.checkIsCashPay() ? false : true;
            // console.log('changeHandlerList',this.checkIsCashPay());
            rows.apRealAmt = rows.apApplyNo.apRealAmt;
            rows.apAmt = rows.apApplyNo.apAmt;
            this.ruleForm.depositReceivableOptions.forEach(item => {
                item['disabled'] = false;
            });
            this.ruleForm.receivableTransferDepositModel.forEach(item => {
                if (item.apApplyNo !== '') {
                    this.ruleForm.depositReceivableOptions.find(item2 => {
                        return item2.montage === item.apApplyNo.montage;
                    }).disabled = true;
                }
            });
        },
        clearHandClick(index, rows) {
            if (this.ruleForm.depositReceivableOptions[index] !== undefined) {
                this.ruleForm.depositReceivableOptions[index].disabled = false;
            } else {
                rows.splice(index, 1);
            }
        },
        electronicSign(formName) {
            if (!this.checkPayment()) {
                return false;
            }
            this.$emit('electronicSign', { state: true,
                data: this.ruleForm,
                total: this.total,
                supCashNo: this.$route.query.supCashNo,
                supCode: this.dataPayLists.suppCode,
                fileId: this.pictureId,
                fileName: this.imgName,
                deid: this.deid });
        },
        paymentOk(formName) {
            this.isDisable = true;
            setTimeout(() => {
                this.isDisable = false;
            }, TIMER.FIVE_THOUSAND);
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const appLists = this.ruleForm.applicationForPaymentModel[0];
                    appLists.payType = this.dataValue;
                    if (appLists.payType === '1' && appLists.imgUrl === '') {
                        return this.$message.warning('请选择一张图片上传');
                    }
                    if (!this.checkPayment()) {
                        return false;
                    }
                    // 当【是否电子签章】选择否，则必须上传附件
                    if (!this.checkIsCashPay && this.eSign === '0') {
                        if (!this.footerFileId) {
                            this.$message.warning('请上传盖章后的《押金调整函件》后再提交支付申请');
                            return false;
                        }
                        this.imgName = this.footerFileName;
                        this.pictureId = this.footerFileId;
                    }
                    this.$emit('paymentOk', { state: true,
                        data: this.ruleForm,
                        total: this.total,
                        supCashNo: this.$route.query.supCashNo,
                        supCode: this.dataPayLists.suppCode,
                        fileId: this.pictureId,
                        fileName: this.imgName,
                        deid: this.deid,
                        checkIsCashPay: this.checkIsCashPay });
                } else {
                    this.$emit('paymentOk', { state: false, form: valid, data: {}, supCashNo: this.$route.query.supCashNo, checkIsCashPay: this.checkIsCashPay });
                    return false;
                }
            });
        },
        paymentShowClose() {
            messageBox(this).then(() => {
                this.$emit('paymentShowClose', '');
            }).catch(() => {});
        },
        inputpayMoney(val, scope) {
            this.ruleForm.applicationForPaymentModel[scope.$index].applyAmt = onlyInputnumber(String(val));
        },
        accountAdjustment(val, scope) {
            this.ruleForm.depositTransfer[scope.$index].applyAmt = onlyInputnumber(String(val));
        },
        accountFocus(val, scope) {
            if (scope.row.fromSupCashNo === '') {
                return this.$message.warning('请先选择当前单据对应的押金单号');
            }
        },
        depositReceivable(val, scope) {
            this.ruleForm.receivableTransferDepositModel[scope.$index].applyAmt = onlyInputnumber(String(val));
        },
        depositChange(val, scope) {
            if (scope.row.apApplyNo === '') {
                return this.$message.warning('请先选择当前单据对应的未结单号');
            }
        },
        handleSubmit(data) {
            this.payResult = data;
            setTimeout(() => {
                document.getElementById('formCommit').submit();
            }, TIMER.FIVE_THOUSAND);
        }
    },
    computed: {
        total() {
            var num = '';
            var pay = 0;
            var cash = 0;
            var depositReceivableMoney = 0;
            this.ruleForm.applicationForPaymentModel.forEach((item, index) => {
                pay += Number(item.applyAmt);
            });
            this.ruleForm.depositTransfer.forEach((item, index) => {
                cash += Number(item.applyAmt);
            });
            this.ruleForm.receivableTransferDepositModel.forEach((item, index) => {
                depositReceivableMoney += Number(item.applyAmt);
            });
            num = ((Number(pay) * CHECK.TEN_THOUSAND + Number(cash) * CHECK.TEN_THOUSAND +
             Number(depositReceivableMoney) * CHECK.TEN_THOUSAND
            ) / CHECK.TEN_THOUSAND
            ).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return num;
        },
        // 是否现金付款
        checkIsCashPay() {
            // 判断押金调账是否有押金单号或者应收转押金是否有未结单号
            const depoLists = this.ruleForm.depositTransfer || [];
            const receivableList = this.ruleForm.receivableTransferDepositModel || [];
            const hasDepositNo = depoLists.some(item => item.fromSupCashNo && item.fromSupCashNo !== '');
            const hasReceivableNo = receivableList.some(item => item.apApplyNo && item.apApplyNo !== '');
            return !(hasDepositNo || hasReceivableNo);
        }
    }
};
</script>

<style lang="less">
@import './payment.less';
</style>
